import { createSlice} from '@reduxjs/toolkit';
import WalletConnect from '@walletconnect/client';
import QRCodeModal from 'algorand-walletconnect-qrcode-modal';
import { RootState } from '../../store';

interface WalletConnectState {
  accounts: string[];
  connected: boolean;
  connector: WalletConnect | null;
}

const initialState = {
  accounts: [],
  connected: false,
  connector: null,
} as WalletConnectState;

export const walletConnectSlice = createSlice({
  name: 'walletConnect',
  initialState,
  reducers: {
    reset: (state) => {
      state.accounts = [];
      state.connected = false;
      state.connector = null;
    },
    walletConnectInit: (state) => {
      console.log('init wallet connect');
      // Create a connector
      state.connector = new WalletConnect({
        bridge: 'https://bridge.walletconnect.org',
        qrcodeModal: QRCodeModal,
      });
    },

    onConnect: (state, action) => {
      const { accounts } = action.payload.params[0];
      state.connected = true;
      state.accounts = accounts;
    },
    onSessionUpdate: (state, action) => {
      state.accounts = action.payload;
    },
    killSession: (state) => {
      state.connector && state.connector.killSession();
      state.accounts = [];
      state.connected = false;
      state.connector = null;
    },
  },
});

export const selectConnected = (state: RootState) =>
  state.walletConnect && state.walletConnect.connected;
export const selectConnector = (state: RootState) =>
  state.walletConnect && state.walletConnect.connector;

export const { reset, walletConnectInit, onConnect, onSessionUpdate, killSession } =
  walletConnectSlice.actions;

export default walletConnectSlice.reducer;
